<template>
    <van-popup
            v-if="selectProductOutPopupShow" v-model="selectProductOutPopupShow" z-index="100" :close-on-click-overlay="false" @click-overlay="handleClickClose"
            :style="{ height: '100vh',width: '100vw', background: '#fff' }" overlay-class="custom_popup" position="right">

        <div class="product_out_wrap" v-loading="loading">
            <div class="product_out_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
                <div class="search_wrap">
                    <van-search v-model="keyword"  placeholder="请输入产品名称"  @clear="handleClickSearch" @search="handleClickSearch"></van-search>
                </div>
            </div>
            <div class="product_out_bottom">
                <div class="product_out_bottom_left">
                    <ul>
                        <li @click="handleClickStockItem({id:''})" :class="stock_id === '' ? 'active' : ''">全部产品</li>
                        <li @click="handleClickStockItem(item)" :class="stock_id == item.id ? 'active' : ''" v-for="item in stockList" v-text="item.name"></li>
                    </ul>
                </div>

                <div class="product_out_bottom_right">
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="item in  tableData">
                            <div class="title_text">
                                <div v-text="item.name"></div>
                                <p v-for="stock in item.stocks">
                                    {{stock.name}} {{stock.total_num}} {{item.unit}}
                                </p>
                            </div>
                            <div class="btns">
                                <span @click="handleClickConfirm(item)">选择</span>
                            </div>
                        </li>
                    </ul>
                </div>




            </div>
        </div>
    </van-popup>

</template>

<script>
import { searchOutProducts,stockList} from "@/api/index.js"
import {pagination} from '@/mixins'
export default {
    name: "select_product_out",
    components: {},
    props: {
        selectProductOutPopupShow: {
            type: Boolean,
            default: false,
        },
        selectStockId: {
            type: [Number, String],
            default: ''
        },
    },
    data() {
        return {
            keyword:'',
            BtnDisabled:false,
            tableData:[],
            stockList:[],
            stock_id:'',

        };
    },
    mixins: [pagination],
    created() {
        if(this.selectStockId){
            this.stock_id = this.selectStockId
        }
        this.getStockList()
        this.getTableData()

    },
    methods: {
        // 获取仓库
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        handleClickStockItem(item){
            this.stock_id = item.id
            this.handleClickSearch()
        },
        handleClickSearch(){
            this.tableData = []
            this.pagination.pageNum = 1
            this.getTableData()
        },
        onLoadList(){
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.keyword,
                stock_id: this.stock_id,
            }
            searchOutProducts(postData).then(res => {
                if (res.code === 200) {
                    // let {list, total} = res.data
                    // this.tableData = list
                    // this.pagination.total = total
                    this.tableData =  this.tableData.concat(res.data)
                    this.pagination.pageNum++;
                }
                this.loading = false
            })
        },
        handleClickConfirm(item) {
            this.$emit("success", item)
            this.$emit("update:selectProductOutPopupShow", false)

        },
        handleClickClose(){
            this.$emit("update:selectProductOutPopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
.custom_popup {
    background-color: rgba(0, 0, 0, 0.3);
}
.product_out_wrap{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    .product_out_top{
        width: 100%;
    }
    .product_out_bottom{
        width: 100%;
        flex: 1;
        display: flex;
        .product_out_bottom_left{
            width: 92px;
            background: rgba(247, 248, 250, 1);
            height: calc(100vh - (100px + env(safe-area-inset-bottom)));
            overflow: auto;
            ul{
                width: 100%;
                li{
                    padding: 10px 16px;
                    line-height: 18px;
                    text-align: center;
                    font-size: 12px;
                    color: rgba(102, 102, 102, 1);
                    &.active{
                        background: #fff;
                        color: rgba(25, 144, 255, 1);
                        font-weight: bold;
                    }
                }
            }
        }
        .product_out_bottom_right{
            width: calc(100% - 92px);
            height: calc(100vh - (100px + env(safe-area-inset-bottom)));
            overflow: auto;
            background: #fff;
            ul{
                width: 100%;
                padding: 0 16px 0px 12px;
                box-sizing: border-box;
                li{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 12px 0 10px;
                    border-bottom: 1px solid rgba(232, 232, 232, 1);
                    box-sizing: border-box;
                    .title_text{
                        width: calc(100% - 48px);
                        div{
                            line-height: 22px;
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                            margin-bottom: 4px;
                            font-weight: bold;
                        }
                        p{
                            line-height: 18px;
                            font-size: 12px;
                            color: rgba(102, 102, 102, 1);
                        }
                    }
                    .btns{
                        width: 40px;
                        span{
                            width: 40px;
                            height: 24px;
                            border-radius: 4px;
                            background: rgba(255, 255, 255, 1);
                            border: 1px solid rgba(41, 144, 255, 1);
                            font-size: 12px;
                            color: rgba(41, 144, 255, 1);
                            text-align: center;
                            line-height: 22px;
                            box-sizing: border-box;
                            display: block;
                        }
                    }
                }
            }
        }
    }
}

</style>